<template>
    <div class="md-cta layout1 mg-bg" :style="{ marginBottom, ...colorStyle, ...spaceStyle, '--background-attachment': backgroundAttachment }">
        <banner
            ref="banner"
            :class="{
                'mg-container': !fullColumn,
                'mobile-no-margin': mobileNoMargin
            }"
            :type="col1Type"
            :sizeOption="sizeOption"
            :useMobileSettings="false"
            :pictureOption="col1Picture"
            :pictureListOption="col1PictureListOption"
            :maskOption="newMaskOption"
            :rawDot="true"
        >
            <div class="f-col" :class="col1Align">
                <div class="cta-content" v-animated="{name: 'fade-in', duration: 1500, enable: showAnimationEffects}">
                    <site-title
                        :title="col1Title"
                        :align="col1Align"
                        role="heading"
                        :aria-level="1"
                    />
                    <site-sub-title
                        :title="col1SubTitle"
                        :size="16"
                        :mbSize="16"
                        :align="col1Align"
                        role="heading"
                        :aria-level="3"
                    />
                    <banner-button
                        :buttons="col1Buttons"
                        @callback="showRegisterPop"
                    />
                </div>      
            </div>      
        </banner>
    </div>
</template>

<script>
import common from '../index';
import colorMixin from '@/modules/color-mixin';
export default {
    mixins: [common, colorMixin({ '--g-bg-color': ['col1BackgroundColor'] })],
    data: function() {
        return {
            maskOption: {
                showMask: true,
                maskColor: 'rgba(0,0,0,0.5)',
            },
            backgroundAttachmentFixed: true
        }
    },
    computed: {
        newMaskOption() {
            let { showMask, maskColor } = this.maskOption;
            showMask = this.col1Type != 'color' && showMask;
            return { showMask, maskColor };
        },
        backgroundAttachment() {
            return this.backgroundAttachmentFixed ? 'fixed' : 'initial'
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

.md-cta.layout1 {
    .banner {
        flex-direction: column;
        .single-picture {
            background-attachment: var(--background-attachment);
            @include media-600 {
                background-attachment: unset;
                bottom: -1px;
            }
        }
        .f-col{
            display: flex;
            &.left{
                justify-content: flex-start;
                .cta-content{
                    align-items: flex-start;
                }
            }
            &.center{
                justify-content: center;
            }
            &.right{
                justify-content: flex-end;
                .cta-content{
                    align-items: flex-end;
                }
            }
        }
        .cta-content{
            z-index: calc(var(--level-sublow) + 1);
            max-width: 1000px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .site-title{
                margin-bottom: 30px;
            }
            .banner-button-v2{
                width: auto;
                margin-top: 40px;
                .btn-item{
                    margin: 0;
                    font-size: 16px;
                    min-width: 200px;
                    height: 50px;
                    line-height: 50px;
                }
            }
            @include media-600 {
                .site-title{
                    margin-bottom: 15px;
                }
                .banner-button-v2{
                    margin-top: 20px;
                }
            }
        }

        .default-bg {
            background: rgba(25, 25, 25, 1);
        }
    }
    .banner-mask {
        opacity: 1;
    }
}
</style>
